import downloadwhite from "../assets/images/download-white.svg";
import { openLeadCaptureDownload } from "../utils/downloadHelpers";

interface FloatingDownloadCTAProps {
  fileUrl: string;
  label?: string;
}

const FloatingDownloadCTA: React.FC<FloatingDownloadCTAProps> = ({
  fileUrl,
  label = "Brochure",
}) => {
  if (!fileUrl) return null;

  return (
    <button
      type="button"
      onClick={() =>
        openLeadCaptureDownload({
          fileUrl,
          title: `Download ${label}`,
          successMessage: "Your document download has started successfully.",
        })
      }
      className="fixed bottom-24 right-6 z-[9998] flex h-14 w-14 items-center justify-center rounded-full bg-primary-red text-primary-white shadow-2xl transition hover:scale-105 hover:bg-red-700 active:scale-95"
      aria-label={`Download ${label}`}
    >
      <img src={downloadwhite} alt="download icon" className="h-7 w-7" />
    </button>
  );
};

export default FloatingDownloadCTA;
